import { isThirdPartyConsentGranted } from './cookie-consent';
import { isGlobalPrivacyControlEnabled } from './global-privacy-control';

/** Google Analytics / Facebook tags (via GTM) may load only with consent and without GPC. */
export function isAnalyticsAllowed(): boolean {
    return isThirdPartyConsentGranted() && !isGlobalPrivacyControlEnabled();
}
